// Do NOT add "use client" to this file
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { getImage } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/getImage";

export interface BrandPageImageProps {
  productToken?: string;
  brandName: string;
  image: IImage;
  productName: string;
  // In rsc tile, we get this from `productsResult`, in non-rsc, we get it from `useProductsQueryData`
  showVerticalImagery?: boolean;
}
// This is RSC ready as long as we searialize brand on server.
export const brandProductImagePropsILeanProductTileAdapter = (
  productTile: ILeanProductTile,
  brandName: string,
  showVerticalImagery?: boolean
): BrandPageImageProps => {
  const image = getImage(productTile);
  return {
    productToken: productTile.product?.token,
    image,
    productName: productTile.product?.name ?? "",
    brandName,
    showVerticalImagery,
  };
};
